import React from "react";
import StepRegister from "./StepRegister";

const NewRegister = () => {
  return <StepRegister />;
};

export default NewRegister;